var map = {
	"./AUS_2_tes_summary_score.geojson": 6525,
	"./BEL_2_tes_summary_score.geojson": 889,
	"./BRA_2_tes_summary_score.geojson": 4981,
	"./CAN_2_1_summary_score.geojson": 1055,
	"./CAN_2_2_summary_score.geojson": 7388,
	"./CAN_2_3_summary_score.geojson": 7785,
	"./CHN_2_summary_score.geojson": 5848,
	"./DEU_2_tes_summary_score.geojson": 50,
	"./DNK_2_summary_score.geojson": 1324,
	"./ESP_3_summary_score.geojson": 4476,
	"./FRA_2_tes_summary_score.geojson": 6001,
	"./GBR_3_tes_summary_score.geojson": 3990,
	"./IND_2_tes_summary_score.geojson": 6387,
	"./JPN_3_summary_score.geojson": 3832,
	"./NLD_2_tes_summary_score.geojson": 82,
	"./SWE_2_tes_summary_score.geojson": 2455,
	"./USA_2_AK_1_summary_score.geojson": 7113,
	"./USA_2_AK_2_summary_score.geojson": 6762,
	"./USA_2_AK_3_summary_score.geojson": 383,
	"./USA_2_NOAK_summary_score.geojson": 9816
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9946;